<template>
    <div id="coach-format">
        <div class="select-images panel-coach-format">
            <h2 class="page-header">Wat spreekt je het meest aan? </h2>
            <div class="panel-text-container">
                <p>
                    Bij een coachtraject ga je natuurlijk met je coach in gesprek. Heb je voorkeur voor een specifieke setting?<br>
                    Er zijn meerdere antwoorden mogelijk.
                </p>
            </div>
            <label class="label-header">Kies de coachvormen hieronder. Er zijn meerdere antwoorden mogelijk.</label>
            <div class="form-group row coach-format-option-container">
                <label class="col-6 col-md-4 col-xl-3 coach-format-option" v-for="( format, id ) in formats">
                    <input type="checkbox" :value="id" v-model="answer.format">
                    <img :src="stylesheetPath + '/assets/img/select-images/' + id + '.jpg'">
                    <span class="tick">{{ format }}</span>
                </label>
            </div>
            <div class="form-group row coach-format-option-container">
                <label class="col-6 col-md-6 col-xl-6 coach-format-option">
                    <input type="checkbox" v-model="selectNone">
                    <span class="tick">Geen voorkeur</span>
                </label>
            </div>
            <div class="buttons-container">
                <previous-button />
                <next-button :is-valid="isAnswered.format && isValid('format')" />
            </div>
        </div>
    </div>
</template>

<script>
    import NextButton from "../partials/NextButton";
    import PreviousButton from "../partials/PreviousButton";

    export default {
        name: 'Format',
        components: {
            PreviousButton,
            NextButton
        },
        props: {
            isValid: {
                type: Function
            },
            answer: {
                type: Object
            },
            invalid: {
                type: Object
            },
            isAnswered: {
                type: Object
            }
        },
        computed: {
            selectNone: {
                get: function () {
                    return this.answer.format.length === 1 && this.answer.format.indexOf("") !== -1;
                },
                set: function (value) {
                    if(value) {
                        this.answer.format = [""];
                    }

                    if (!value && this.answer.format.indexOf("") !== -1) {
                        this.answer.format = [];
                    }
                }
            }
        },
        data() {
            return {
                formats: formats,
                stylesheetPath: stylesheetPath,
                rules: {
                    format: {
                        min: 1
                    },
                }
            }
        },
        created() {
            this.$emit('setRules', this.rules)
        }
    }
</script>